export default __webpack_public_path__ + "media/images/dividers/header-bottom-4bcbf84e151448da5ed7d416145319f2.svg";